import { RealEstateDataHeaderData } from 'types'
import React, { Fragment, useEffect, useState } from 'react'
import { makeItemsNav } from '@helpers/helper.rendering'
import { useGetSummarySiteQuery } from '@apis/mediacore/core'
import { Link } from 'gatsby'
import $ from 'jquery'
import { Toaster } from 'react-hot-toast'

const Header12 = ({
  global_data,
  pages,
  fontColor,
  spanText,
  hoverColor,
  height,
  logoSize,
  is_short, //Top side
  isInverted, // Social verticales
  backgroundColor,
}: RealEstateDataHeaderData) => {
  useEffect(() => {
    document.documentElement.style.setProperty('--opacityBG12', logoSize || '100%') // fontColor
    document.documentElement.style.setProperty('--fontcolorNav12', fontColor || '#4d4f54') // fontColor
    document.documentElement.style.setProperty('--bgColorNav12', spanText || '#fff') // spanText
    document.documentElement.style.setProperty('--bgColorMenu12', backgroundColor || '#dddddd') // backgroundColor
    document.documentElement.style.setProperty('--fontHoverNav12', hoverColor || '#00A1FF') //hoverColor
    document.documentElement.style.setProperty('--heightNav12', height?.desktop || '15vh') //desktop
    document.documentElement.style.setProperty('--widthNav12', height?.mobile || '100px') //ancho
    if ($(window)?.width()! > 992) {
      $('body').css('margin-left', '100px')
    }
  }, [])

  const { id: siteId, logo, logoMobile } = global_data

  const { data: allSiteData } = useGetSummarySiteQuery(
    process.env.GATSBY_IS_SITE_COMPILER == 'true' ? siteId : process.env.GATSBY_TENANTID,
  )

  const getCurrentYear = () => new Date().getFullYear()

  const [menu, setMenu] = useState(false)

  return (
    <Fragment>
      <header
        id="header_12"
        className={
          'atail-header header-12 ' + (menu ? 'open' : '') + (is_short ? ' top-side' : ' ')
        }
      >
        <Toaster></Toaster>
        <div className="bt-mobile"></div>
        <div className="logo-mobile d-block d-lg-none">
          <img
            src={logoMobile}
            alt=""
          />
        </div>
        <div className=" container-fluid d-flex align-items-center">
          <div className="logo atail-logo-portrait"></div>
          <div
            className={'show-nav ' + (menu ? 'active' : '')}
            onClick={() => setMenu(!menu)}
          >
            <span data-action="show-nav">
              <span>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </span>
          </div>
          <nav className="row">
            <ol
              id="menu-menu-1"
              className={'nav-list ' + (menu ? 'open' : '')}
            >
              <div className="d-lg-none side-content-mobile">
                <div className={'side-content ' + (isInverted ? 'normal-side' : '')}>
                  {global_data.pageConfig.social.instagram && (
                    <a
                      className="icon-instagram"
                      href={global_data.pageConfig.social.instagram}
                    ></a>
                  )}
                  {global_data.pageConfig.social.linkedin && (
                    <a
                      className="icon-linkedin"
                      href={global_data.pageConfig.social.linkedin}
                    ></a>
                  )}
                  {global_data.pageConfig.social.facebook && (
                    <a
                      className="icon-facebook"
                      href={global_data.pageConfig.social.facebook}
                    ></a>
                  )}
                  {global_data.pageConfig.social.youtube && (
                    <a
                      className="icon-youtube"
                      href={global_data.pageConfig.social.youtube}
                    ></a>
                  )}
                  {global_data.pageConfig.social.twitter && (
                    <a
                      className="icon-twitter"
                      href={global_data.pageConfig.social.twitter}
                    ></a>
                  )}
                  {global_data.pageConfig.social.tiktok && (
                    <a
                      className="icon-tiktok"
                      href={global_data.pageConfig.social.tiktok}
                    ></a>
                  )}
                </div>
              </div>
              {makeItemsNav(
                allSiteData?.propiedades,
                allSiteData?.novedades,
                pages,
                allSiteData?.posiciones,
                true,
                true,
              )
                .filter((page) => !page.path.includes('detalle'))
                .map(({ path, title }, index) => (
                  <li
                    key={index}
                    className="menu-item col-xs-2 "
                  >
                    <Link
                      onClick={() => setMenu(false)}
                      to={path}
                      activeClassName="active"
                    >
                      {/* <span className="number">0{index + 1}</span> */}
                      <span>{title}</span>
                    </Link>
                  </li>
                ))}
            </ol>
          </nav>
        </div>
      </header>
      <div className="left-side header-side-12">
        <Link
          to="/"
          aria-label="Inicio"
        >
          <span className="atail-text-logo">
            <img
              src={logo}
              alt="Mediahaus"
            />
          </span>
        </Link>
        <div className={'side-content ' + (isInverted ? 'normal-side' : '')}>
          {global_data.pageConfig.social.instagram && (
            <a
              className="icon-instagram"
              href={global_data.pageConfig.social.instagram}
            ></a>
          )}
          {global_data.pageConfig.social.linkedin && (
            <a
              className="icon-linkedin"
              href={global_data.pageConfig.social.linkedin}
            ></a>
          )}
          {global_data.pageConfig.social.facebook && (
            <a
              className="icon-facebook"
              href={global_data.pageConfig.social.facebook}
            ></a>
          )}
          {global_data.pageConfig.social.youtube && (
            <a
              className="icon-youtube"
              href={global_data.pageConfig.social.youtube}
            ></a>
          )}
          {global_data.pageConfig.social.twitter && (
            <a
              className="icon-twitter"
              href={global_data.pageConfig.social.twitter}
            ></a>
          )}
          {global_data.pageConfig.social.tiktok && (
            <a
              className="icon-tiktok"
              href={global_data.pageConfig.social.tiktok}
            ></a>
          )}
        </div>
        <a className="copy">{getCurrentYear()} MediaHaus©</a>
      </div>
    </Fragment>
  )
}

export default Header12
